import React, { useState } from 'react';

import { RenewalStatus } from '@appTypes/enums';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import EditParticipationModal from '@modules/shared/components/DroppingStatus/EditParticipationModal';
import Spin from '@shared/components/Spin';
import Switch from '@shared/components/Switch';
import { intl } from '@shared/localization';

export const OptoutColumn: React.FC<{
  renewalStatus: string;
  personGuid: string;
  registrationId?: number;
  bsaOrderId?: number;
  canOptOut: boolean;
  areRenewalsLoading: boolean;
  handleSwitchClick: React.MouseEventHandler<HTMLDivElement>;
  handleSwitchOptout: (personGuid: string, registrationId: number) => void;
}> = props => {
  const [modalVisible, setModalVisible] = useState(false);
  const isOptedOut = props.renewalStatus === RenewalStatus.OptedOut;

  const {
    renewalStatus,
    registrationId,
    canOptOut,
    personGuid,
    areRenewalsLoading,
    handleSwitchClick,
    handleSwitchOptout,
  } = props;

  if (areRenewalsLoading) {
    return <Spin size="small" />;
  }

  if (!registrationId) return null;

  const disableSwitch = featureFlags.getFlag('SBL_5110_FORCE_ENABLE_OPT_OUT')
    ? false
    : areRenewalsLoading || !canOptOut;

  return (
    <div onClick={handleSwitchClick}>
      {!disableSwitch && (
        <EditParticipationModal
          isOptedOut={isOptedOut}
          personGuid={props.personGuid}
          registration={{
            registrationId: props.registrationId!,
            bsaOrderId: props.bsaOrderId,
            renewalStatus: renewalStatus as RenewalStatus,
            // we don't have org name in this context but it applies to current org selected
            organizationName: intl.formatMessage({
              id: 'youthMembership.optoutModal.currentUnitLabel',
            }),
          }}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
        />
      )}
      <Switch
        disabled={disableSwitch}
        size="small"
        checked={renewalStatus === RenewalStatus.OptedOut}
        onChange={
          featureFlags.getFlag('SBL_5450_DROP_OUT')
            ? () => setModalVisible(true)
            : handleSwitchOptout(personGuid, registrationId)
        }
      />
    </div>
  );
};
